module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "1000px",
      "margin": "50px auto"
    }
  }, [_c('dl', {
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  }, [_vm._v("\n        " + _vm._s(_vm.content) + "\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a5a8402"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/xieyi.vue
// module id = 1084
// module chunks = 1